import {
  ordLanguageFrench,
  resourcesLanguageFrench as ordResourceLanguageFrench,
  raLanguageFrench,
} from '@ragu-components/ord-providers';
import { raFormLayoutLanguageFrench } from '@ratto-components/ra-form-layout';
import { raRelationshipsLanguageFrench } from '@ratto-components/ra-relationships';

import { callflowLanguageFrench } from './callflows/';
import { resourcesLanguageFrench } from './resources';

import type { TranslationMessages } from './translationMessages';

export const languageFrench: TranslationMessages = {
  ...raLanguageFrench,
  ...raFormLayoutLanguageFrench,
  ...raRelationshipsLanguageFrench,
  ...callflowLanguageFrench,
  ...ordLanguageFrench,
  ...resourcesLanguageFrench,
  ...ordResourceLanguageFrench,
  ord: {
    ...(ordLanguageFrench.ord ?? {}),
    permissions: {
      ...(ordLanguageFrench.ord?.permissions ?? {}),
      ap_configurations: "Configurations d'AutoProvisioning",
      ap_groups: "Groupes d'AutoProvisioning",
      ap_authentication: "Authentification d'AutoProvisioning",
      ap_settings: "Paramètres d'AutoProvisioning",
      ap_templates: "Modèles d'AutoProvisioning",
      assigned_carriers: 'Trunk SIP du Domaine',
      assigned_inbound_e164s: 'E164 Entrant du Domaine',
      assigned_lcrs: 'LCR du Domaine',
      assigned_sip_profiles: 'Profils SIP du Domaine',
      calls: 'Appels',
      encryption_configurations: 'Clés de chiffrement du stockage',
      presence: 'Présence',
      storage_configurations: 'Configurations de Stockage Externe',
    },
    validation: {
      ...(ordLanguageFrench.ord?.validation ?? {}),
      pattern: 'Format invalide',
    },
    menu: {
      ...(ordLanguageFrench.ord?.menu ?? {}),
      callManagementLabel: 'Gestion des appels',
    },
  },
  callForwarding: {
    description: "Gérez vos règles de renvoi d'appels",
    settingButtonLabel: 'Configurer',
  },
  common: {
    unsavedChanges: {
      message: 'Vous avez des modifications non enregistrées. Voulez-vous vraiment quitter ?',
    },
  },
};
